module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'campaign-code ' + _vm.cssStateClasses
  }, [(_vm.isValid === _vm.CODE_STATE.NOT_TRIED || _vm.isValid === _vm.CODE_STATE.CHECKING || _vm.isValid === _vm.CODE_STATE.INVALID) ? _c('div', [_c('p', [_vm._v("Har du en kampanjkod? Använd den här.")]), _vm._v(" "), _c('div', {
    staticClass: "code-wrapper"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    class: {
      error: !!_vm.errorMessage
    },
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tryCode($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "small",
    attrs: {
      "disabled": !_vm.code
    },
    on: {
      "click": _vm.tryCode
    }
  }, [_vm._v("Använd")])])]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    class: 'error-message'
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isValid === _vm.CODE_STATE.VALID || _vm.isValid === _vm.CODE_STATE.REMOVING) ? _c('div', {
    staticClass: "code-wrapper"
  }, [_c('div', {
    staticClass: "code-wrapper-inner"
  }, [_c('div', {
    staticStyle: {
      "padding-right": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "1em 0"
    }
  }, [_vm._v("Bokar med kampanjkod: "), _c('b', [_vm._v(_vm._s(_vm.code))])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.removeCode
    }
  }, [_vm._v("Ta bort")])])]), _vm._v(" "), (_vm.requiresExtraInput) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "580px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.requiresExtraInputMessage)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraInput),
      expression: "extraInput"
    }],
    class: {
      error: !!_vm.errorMessage
    },
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.extraInput)
    },
    on: {
      "keyup": _vm.updateExtraInfo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.extraInput = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30370817"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/CheckoutCodeModal.vue
// module id = 918
// module chunks = 0